import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';
import whitepaperLiteRaw from '../content/whitepaper-lite.md?raw';

/** Public whitepaper PDF: Lite (simplified) edition only — do not use Whitepaper-Ultimate.pdf here. */
const WHITEPAPER_PDF_URL = '/Whitepaper-Lite.pdf';

/** Internal routes (/nodes, /whitepaper) use Link; static files (.pdf) use <a> for download. */
function MarkdownLink({ href, children, ...props }: { href?: string; children?: React.ReactNode }) {
  if (!href) return <a {...props}>{children}</a>;
  if (href.startsWith('/') && (href.endsWith('.pdf') || href.endsWith('.PDF')))
    return <a href={href} {...props}>{children}</a>;
  if (href.startsWith('/'))
    return <Link to={href} {...props}>{children}</Link>;
  return <a href={href} target="_blank" rel="noopener noreferrer" {...props}>{children}</a>;
}

/**
 * Whitepaper page: renders the Lite Edition whitepaper (public preview).
 * Source: docs/whitepaper/Whitepaper-Lite.md (copied to src/content for build).
 */
export default function WhitepaperPage() {
  return (
    <div className="min-h-screen pt-24 pb-20 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <FileText className="w-10 h-10 text-purple-400" aria-hidden />
          <h1 className="text-4xl font-bold text-white">Whitepaper — Lite Edition</h1>
        </div>
        <div className="bg-slate-800/50 border border-purple-500/30 rounded-xl p-8 md:p-10 markdown-content">
          <ReactMarkdown components={{ a: MarkdownLink }}>{whitepaperLiteRaw}</ReactMarkdown>
        </div>
        <div className="mt-8 flex flex-wrap gap-4">
          <a
            href={WHITEPAPER_PDF_URL}
            className="inline-flex items-center gap-2 px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
            download
          >
            Download PDF (Lite Edition)
          </a>
          <a
            href="https://discord.gg/rRBSnQsxJu"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-slate-600 text-white rounded-lg hover:bg-slate-500 transition-colors"
          >
            Join Discord for full 710-page whitepaper
          </a>
        </div>
      </div>
    </div>
  );
}
